<div class="asset-upload-container h-full">
  <thehubz-asset-settings-stepper
    *ngIf="isReady"
    #stepper
    [class.has-left-area]="
      currentStep.stepperGroupName === 'contentDescription' ||
      currentStep.stepperGroupName === 'generalInformation' ||
      currentStep.stepperGroupName === 'usageRight' ||
      currentStep.stepperGroupName === 'tags'
    "
    [stepperModel]="stepperData"
    [taggingOptions]="taggingOptions"
    [assetListFiles]="assetListFiles"
    [assetListFilesDraft]="assetListFilesDraft"
    [brandingKey]="brandingKey"
    [assetDuplicateFlag]="assetDuplicateFlag"
    [assetExistingFlag]="assetExistingFlag"
    (ready)="onReady()"
    (fieldChange)="onFieldChange($event)"
    (formSubmit)="onSubmit($event)"
    (nameFieldChange)="onNameFieldChange($event)"
    (beforeStepChange)="onBeforeStepChange()"
    (stepChange)="onStepChange($event)"
    (taggedUser)="taggedUserList($event)"
    (descriptionText)="editorDescriptionText($event)"
  >
    <div
      *ngIf="
        draftFlag &&
        (currentStep?.stepperGroupName === 'contentDescription' ||
          currentStep?.stepperGroupName === 'generalInformation' ||
          currentStep?.stepperGroupName === 'usageRight' ||
          currentStep?.stepperGroupName === 'tags')
      "
      leftAreaSlot
      class="overflow-y-auto widget-bg-color"
    >
      <div *ngIf="existingAssetListFiles && existingAssetListFiles.length; else noFilesAdded" class="asset-preivew" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
        <header class="asset-preview-header widget-bg-color">
          <span class="header-column" i18n>Asset</span>
          <span class="header-column name-column" i18n>Name</span>
          <span class="header-column type-column" i18n>Type</span>
        </header>

        <ol class="asset-preview-list">
          <li *ngFor="let file of assetListFilesDraft" class="asset-preview-item">
            <thehubz-asset-item-basic [item]="file" [editFlag]="true" class="elevated rounded"> </thehubz-asset-item-basic>
          </li>
        </ol>
      </div>

      <ng-template #noFilesAdded>
        <div class="flex w-full h-full justify-center items-center" i18n>No files selected</div>
      </ng-template>
    </div>
    <div *ngIf="currentStep.stepperId === '1' && !draftFlag" topAreaSlot class="asset-selector flex flex-col box-border content-center place-items-center items-baseline justify-around mb-4">
      <sp-file-drag-n-drop #fileDragDrop [multipleFile]="true" [required]="true" (uploadedFiles)="addFiles($event)" class="w-full m-auto"> </sp-file-drag-n-drop>
      <div *ngIf="hasFilesError" class="block error-color ml-7 -mt-2 text-xs" i18n>Files are required</div>
    </div>
    <div
      *ngIf="
        !draftFlag &&
        (currentStep.stepperGroupName === 'contentDescription' ||
          currentStep.stepperGroupName === 'generalInformation' ||
          currentStep.stepperGroupName === 'usageRight' ||
          currentStep.stepperGroupName === 'tags')
      "
      leftAreaSlot
      class="overflow-y-auto widget-bg-color"
    >
      <div *ngIf="assetListFiles && assetListFiles.length; else noFilesAdded" class="asset-preivew" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
        <header class="asset-preview-header widget-bg-color">
          <span class="header-column" i18n>Asset ({{ assetListFiles.length }})</span>
          <span class="header-column name-column" i18n>Name</span>
          <span class="header-column type-column" i18n>Type</span>
        </header>

        <ol class="asset-preview-list">
          <li *ngFor="let file of assetListFiles; let i = index" class="asset-preview-item">
            <thehubz-asset-item-basic [item]="file" class="elevated rounded" [ngClass]="{ 'border-outline ': file.isExists || file.isDuplicate }">
              <ng-container assetActionsSlot>
                <div *ngIf="file.isExists" class="flex justify-center items-center ml-3 field-error">
                  <mat-icon class="material-icons-outlined" i18n-matTooltip matTooltip="Assets with the same name already exist. Please change file name before upload if you want to avoid duplicates."
                    >warning_amber</mat-icon
                  >
                </div>
                <div *ngIf="!file.isExists && file.isDuplicate" class="flex justify-center items-center ml-3 field-error">
                  <mat-icon class="material-icons-outlined" i18n-matTooltip matTooltip="Multiple assets with the same name have been uploaded. Double-check to avoid duplication"
                    >warning_amber</mat-icon
                  >
                </div>
                <button mat-icon-button type="button" class="delete-button icon-button-narrow" (click)="removeFile(file, i)">
                  <span class="sr-only" i18n>Remove</span>
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              </ng-container>
            </thehubz-asset-item-basic>
          </li>
        </ol>
      </div>

      <ng-template #noFilesAdded>
        <div class="flex w-full h-full justify-center items-center" i18n>No files selected</div>
      </ng-template>
    </div>
    <ng-template [ngIf]="brandingKey === CustomClients.Standard">
      <ng-template let-formArray let-callFrom="callFrom" let-onDeleteBuyoutRight="onDeleteBuyoutRight" let-onEditBuyoutRights="onEditBuyoutRights" #shortBuyoutRightsSummary>
        <thehubz-buyout-rights-standard
          *ngFor="let buyoutRightCtrl of formArray; let i = index; trackBy: trackByFn"
          [formValue]="buyoutRightCtrl.getRawValue()"
          [buyoutRightsConfigs]="buyoutRightsConfigs"
          [columns]="columns"
          [disableHostStyling]="true"
          [expanded]="false"
          [callFrom]="callFrom"
          (editBuyoutRights)="onEditBuyoutRights(i)"
          (deleteBuyoutRights)="onDeleteBuyoutRight(i, buyoutRightCtrl.getRawValue()?.buyoutRightsTitle?.name)"
        ></thehubz-buyout-rights-standard>
      </ng-template>
    </ng-template>
  </thehubz-asset-settings-stepper>

  <div *ngIf="uploadInProgress" class="upload-progress">
    <div class="progress-wrapper">
      <div class="progress-info">
        <span>
          <ng-container i18n>Upload</ng-container>:
          <span *ngIf="currentUploadFileName" class="upload-file-name"><br />{{ currentUploadFileName }}</span>
        </span>
        <span class="upload-status">{{ progress }}%</span>
      </div>

      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    </div>
  </div>
</div>
